import { Pipe, PipeTransform, inject } from '@angular/core';

import { Globals } from '@core/globals';

@Pipe({
  name: 'phone',
})
export class PhonePipe implements PipeTransform {
  private globals = inject(Globals);

  transform(value: string | number | undefined, spaces?: boolean, code?: boolean): string | undefined {
    if (value === undefined || value === null) return;
    if (typeof value === 'number') value = value.toString();
    value = value.replace(/ /g, '');
    if (spaces) value = value.replace(/(\d{3})(\d{3})(\d{3})/, '$1 $2 $3');
    if (code) {
      const phoneCode = this.globals.defaultPhoneCode[this.globals.language()];
      const space = spaces ? ' ' : '';
      value = phoneCode + space + value;
    }
    return value;
  }
}
